import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/ProgressBar/ProgressBar.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/progress-bar/react/latest'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {ProgressBar} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ProgressBar progress={80} aria-label="Upload test.png" />
`}</code></pre>
    <h3>{`Inline`}</h3>
    <p>{`If you'd like to use ProgressBar inline, pass the `}<inlineCode parentName="p">{`inline`}</inlineCode>{` boolean prop & `}<strong parentName="p">{`be sure to set a width`}</strong>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Text mr={3}>5 of 10</Text>
  <ProgressBar progress={50} inline sx={{width: '100px'}} aria-label="Upload test.png" />
</>
`}</code></pre>
    <h3>{`Multiple Segments`}</h3>
    <p>{`If you want to show multiple segments in a ProgressBar, pass separate `}<inlineCode parentName="p">{`Item`}</inlineCode>{`s as children `}<strong parentName="p">{`instead`}</strong>{` of a `}<inlineCode parentName="p">{`progress`}</inlineCode>{` value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <ProgressBar aria-label="Upload test.png">
    <ProgressBar.Item progress={33} />
    <ProgressBar.Item progress={33} sx={{backgroundColor: 'danger.emphasis'}} />
  </ProgressBar>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      